import VitalSign from "../../../models/core/careLine/VitalSign";
import { GenericService } from "./Generic.service";

export class VitalSignService extends GenericService<VitalSign>{

    readonly URI: string = 'SinalVital'

    constructor(){
        super()
        this.setUri(this.URI);
    }

    public async getAll(){
        return await super.getByResource('', { PageSize: 500 })
    }

    public async getById(id: string){
        return await super.getByResource(`${id}`, { PageSize: 500 })
    }

}